import { apiClient } from "@base/api/client";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { type ProjectTagItem, projectTagItemSchema } from "./projectTagsSchema";

interface CreateProjectTagRequest {
  name: string;
}

async function createProjectTag(projectId: string, body: CreateProjectTagRequest): Promise<ProjectTagItem> {
  const response = await apiClient.post<unknown>(`/project-management/api/projects/${projectId}/tags`, body);
  return projectTagItemSchema.parse(response.data);
}

export function useCreateProjectTagMutation(
  projectId: string,
  options?: Omit<UseMutationOptions<ProjectTagItem, Error, CreateProjectTagRequest>, "mutationFn">,
) {
  return useMutation({
    mutationFn: (body: CreateProjectTagRequest) => createProjectTag(projectId, body),
    ...options,
  });
}
